import React, { Component, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Grid,
    Button,
} from '@material-ui/core';

import { Translate } from '../../Localization/Translate';
import Api from '../../../nibeApi';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Locale } from './../../Locale/Locale';

class Summary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentLoaded: false,
            emailCheckValue: '',
            classes: '',
            summaryObject: null,
            isCreateQuoteLoading: false,
            isLoading: true,
            showEmptyResponseMessage: false,
        };
    }

    componentDidMount() {
        this.getSummary();
        this.setState({
            componentLoaded: true
        });
    }

    updateInputData(elementName, value) {

        this.setState({
            [elementName]: value,
        });
    }

    getSummary = () => {
        const { showSummaryData, summaryData, coolingAndWarmWaterObject } = this.props;
        const scope = this;
        let data = "pumpType=" + summaryData.pumpType.value.toString();
        data += "&pumpSeries=" + summaryData.pump.value.toString();
        data += "&cooling=" + (coolingAndWarmWaterObject.quoteCooling ? "true" : "false");
        data += "&power=" + summaryData.power.value.toString();
        data += "&waterFlow=" + (coolingAndWarmWaterObject.waterPeak ? coolingAndWarmWaterObject.waterPeak.toString() : "0");
        data += "&market=" + this.props.config;
        data += "&culture=" + window.__nibe.culture;
        data += "&projectName=" + this.props.projectName;
        data += "&gasUsage=" + summaryData.gasUsage;

        Api.makeCall("get",
            'Pumps/summary?' + data,
            {},
            false,
            function (response) {
                if (response && response.data) {

                    scope.setState({
                        newCustomerDataSentOk: true,
                        summaryObject: response.data,
                        isLoading: false,
                        showEmptyResponseMessage: false,
                    });
                }
            },
            function () {
                scope.setState({ isLoading: false, showEmptyResponseMessage: true });
            });
    };

    sendQuote = () => {
        const {  summaryData, coolingAndWarmWaterObject, powerValues } = this.props;
        this.setState({ isCreateQuoteLoading: true });
        
        let data = {
            projectName: this.props.projectName,
            market: this.props.config,
            culture: window.__nibe.culture,
            emailAddress: this.props.email,
            pumpType: summaryData.pumpType.value.toString(),
            pumpSeries: summaryData.pump.value.toString(),
            power: {
                power: this.props.power,
                livingArea: powerValues.livingArea,
                ventilationType: powerValues.ventilationValue
            },
            buildingType: powerValues.buildingType,
            gasUsage: powerValues.gasUsage,
            tapWater: {
                waterFlow: coolingAndWarmWaterObject.waterPeak ?? 0,
                householdSize: coolingAndWarmWaterObject.quotePersons ?? 0,
                averageShoweringTime: coolingAndWarmWaterObject.quoteTime ?? 0,
                showerFlow: coolingAndWarmWaterObject.showerTypes ?? 0,
                bathtubVolume: coolingAndWarmWaterObject.quoteBath ?? 0,
            },
            cooling: coolingAndWarmWaterObject.quoteCooling,
        }
        const { updateState, activeStep } = this.props;

        Api.makeCall("post", 'Quote', data, false, function (response) {
            if (updateState) {
                updateState("activeStep", activeStep + 1);
            }
        });
    };

    handleBack = () => {
        const { updateState, activeStep } = this.props;
        if (updateState) {
            updateState("activeStep", activeStep - 1);
        }
    };
    render() {
        const classes = makeStyles((theme) => ({
            root: {
                width: '100%',
            },
        }));

        const { summaryObject } = this.state;
        var format = require('string-template');

        let totalSum = 0;
        if (summaryObject) {
            totalSum += summaryObject.pump ? summaryObject.pump.price : 0;

            summaryObject.boilers.forEach((boiler => { totalSum += boiler.price; }));
            summaryObject.boilerAccessories.forEach((accessory => { totalSum += accessory.price; }));
            summaryObject.pumpAccessories.forEach((accessory => { totalSum += accessory.price; }));
        }

        return (
            <div>
                <form className={classes.root} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>

                    {this.state.isLoading ? (
                        <CircularProgress color='secondary' size={60} />
                    ) : null}

                    {this.state.showEmptyResponseMessage ? <p>{Translate('QuoteTool/step5/emptyresponse')}</p> : null}

                    {summaryObject && summaryObject.pump ?
                        <>
                            <h5 className='sub-header'>{Translate("QuoteTool/step5/selectedpumplabel")}</h5>
                            <Grid container alignItems="flex-start" spacing={2}>
                                <Grid item xs={3}>
                                    <b>{summaryObject.pump.articleNumber}</b>
                                </Grid>
                                <Grid item xs={6}>
                                    {summaryObject.pump.description}
                                </Grid>
                                <Grid item xs={3} align="right" className="summary__content--last-column">
                                    {format(Translate('QuoteTool/general/currency'), [
                                        Locale.getNumberFormatString(
                                            summaryObject.pump.price
                                        )
                                    ])}
                                </Grid>
                            </Grid>
                        </> : null}

                    {summaryObject && summaryObject.pumpAccessories && summaryObject.pumpAccessories.length > 0 ? (
                        <>
                            <h5 className='sub-header'>{Translate("QuoteTool/step5/selectedpumpacclabel")}</h5>
                            {summaryObject.pumpAccessories.map((accessory, index) => {
                                return (<Grid container alignItems="flex-start" spacing={2} key={'pAccessory' + index}>
                                    <Grid item xs={3}><b>{accessory.articleNumber}</b></Grid>
                                    <Grid item xs={6}>{accessory.description}</Grid>
                                    <Grid item xs={3} align="right" className="summary__content--last-column">
                                        {format(Translate('QuoteTool/general/currency'), [
                                            Locale.getNumberFormatString(
                                                accessory.price
                                            )
                                        ])}
                                    </Grid>
                                </Grid>);
                            })}
                        </>
                    ) : null}

                    {summaryObject && summaryObject.boilers && summaryObject.boilers.length > 0 ?
                        <>
                            <h5 className='sub-header'>{Translate("QuoteTool/step5/selectedboilerlabel")}</h5>
                            {summaryObject.boilers.map((boiler, index) => {
                                return (
                                    <Grid container alignItems="flex-start" spacing={2}>
                                        <Grid item xs={3}>
                                            <b>{boiler.articleNumber}</b>
                                        </Grid>
                                        <Grid item xs={6}>
                                            {boiler.description}
                                        </Grid>
                                        <Grid item xs={3} align="right" className="summary__content--last-column">
                                            {format(Translate('QuoteTool/general/currency'), [
                                                Locale.getNumberFormatString(
                                                    boiler.price
                                                )
                                            ])}
                                        </Grid>
                                    </Grid>);
                            })}
                        </> : null}

                    {summaryObject && summaryObject.boilerAccessories && summaryObject.boilerAccessories.length > 0 ? (
                        <>
                            <h5 className='sub-header'>{Translate("QuoteTool/step5/selectedboileracclabel")}</h5>
                            {summaryObject.boilerAccessories.map((accessory, index) => {
                                return (
                                    <Grid container alignItems="flex-start" spacing={2} key={'bAccessory' + index}>
                                        <Grid item xs={3}><b>{accessory.articleNumber}</b></Grid>
                                        <Grid item xs={6}>{accessory.description}</Grid>
                                        <Grid item xs={3} align="right" className="summary__content--last-column">
                                            {format(Translate('QuoteTool/general/currency'), [
                                                Locale.getNumberFormatString(
                                                    accessory.price
                                                )
                                            ])}
                                        </Grid>
                                    </Grid>);
                            })}
                        </>
                    ) : null}

                    {summaryObject && summaryObject.optionalAccessories && summaryObject.optionalAccessories.length > 0 ? (
                        <>
                            <h5 className='sub-header'>{Translate("QuoteTool/step5/optionalaccessories")}</h5>
                            {summaryObject.optionalAccessories.map((accessory, index) => {
                                return (
                                    <Grid container alignItems="flex-start" spacing={2} key={'oAccessory' + index} >
                                        <Grid item xs={3}><b>{accessory.articleNumber}</b></Grid>
                                        <Grid item xs={6}>{accessory.description}</Grid>
                                        <Grid item xs={3} align="right" className="summary__content--last-column">
                                            {format(Translate('QuoteTool/general/currency'), [
                                                Locale.getNumberFormatString(
                                                    accessory.price
                                                )
                                            ])}
                                        </Grid>
                                    </Grid>);
                            })}
                        </>
                    ) : null}

                    {summaryObject && totalSum > 0 ?
                        <Grid container alignItems="flex-start" spacing={2} className='summary__totalPrice'>
                            <Grid item xs={6}>
                                <h5 className='summary__totalPrice--colored'>
                                    {Translate('QuoteTool/step5/totalprice')}
                                </h5>
                            </Grid>

                            <Grid item xs={6} align="right" className="summary__content--last-column">
                                <h5>
                                    {format(Translate('QuoteTool/general/currency'), [
                                        Locale.getNumberFormatString(
                                            totalSum
                                        )
                                    ])}
                                </h5>
                            </Grid>
                        </Grid>
                        : null}

                </form>
                <Grid container alignItems="flex-start" spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleBack}
                            className={classes.button}
                        >
                            {Translate("QuoteTool/general/buttonback")}
                        </Button>&nbsp;
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.sendQuote()}
                            className={classes.button}
                            disabled={!summaryObject || this.state.isCreateQuoteLoading}
                        >
                            {this.state.isCreateQuoteLoading ? <CircularProgress color='primary' color='secondary' className='button-loader' size={20} /> : null}
                            {Translate("QuoteTool/step5/createquotebutton")}
                        </Button>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default Summary;